import { toSharedDomesticOrder } from '~/app/components/order-converter/converter/DomesticOrderConverter'
import {
  toSharedLeisureOrder,
  toSharedLeisureItem,
} from '~/app/components/order-converter/converter/LeisureOrderConverter'
import { toSharedTrainOrder } from '~/app/components/order-converter/converter/TrainOrderConverter'
import { SharedOrderQuery } from '~/__generated__/app/query/order-shared/order-shared-list.graphql'
import { toSharedBusOrder } from '~/app/components/order-converter/converter/BusOrderConverter'

/**
 * useSharedOrderConverter
 * author: soojin.oh
 */

// type definitions
export type CategoryOrders = SharedOrderQuery['sharedOrder']['categoryOrders']
export type CategoryOrder = ArrayItem<CategoryOrders>

// hook
const useSharedOrderConverter = function () {
  return {
    toSharedDomesticOrder,
    toSharedLeisureOrder,
    toSharedLeisureItem,
    toSharedTrainOrder,
    toSharedBusOrder,
  }
}

export default useSharedOrderConverter
